import React from 'react';
import PropTypes from 'prop-types';
import './Section.css';

/**
 * Componente Section - Container padronizado para seções do site
 * 
 * Inclui:
 * - Espaçamento consistente
 * - Container responsivo
 * - Título e subtítulo opcionais
 * - Background customizável
 */
const Section = ({ 
  children,
  title,
  subtitle,
  description,
  background = 'default',
  centered = false,
  id,
  className = '',
  noPadding = false,
  ...props 
}) => {
  
  const sectionClasses = [
    'section-wrapper',
    `section-wrapper--${background}`,
    noPadding ? 'section-wrapper--no-padding' : '',
    className
  ].filter(Boolean).join(' ');

  const contentClasses = [
    'section-content',
    centered ? 'section-content--centered' : ''
  ].filter(Boolean).join(' ');

  return (
    <section id={id} className={sectionClasses} {...props}>
      <div className="container">
        {/* Header da Seção */}
        {(title || subtitle || description) && (
          <div className={`section-header ${centered ? 'section-header--centered' : ''}`}>
            {subtitle && (
              <span className="section-subtitle">{subtitle}</span>
            )}
            {title && (
              <h2 className="section-title">{title}</h2>
            )}
            {description && (
              <p className="section-description">{description}</p>
            )}
          </div>
        )}

        {/* Conteúdo da Seção */}
        <div className={contentClasses}>
          {children}
        </div>
      </div>
    </section>
  );
};

Section.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  background: PropTypes.oneOf(['default', 'alt', 'dark', 'gradient', 'primary']),
  centered: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  noPadding: PropTypes.bool,
};

export default Section;
